<!--  -->
<template>
  <div :class="['coupon-item', id == item.id ? 'active-coupon-item' : '']">
    <div class="coupon-type">
      <span>
        {{ item.couponType != null ? $optionsData.couponType[item.couponType].label : "" }}
        {{ item.couponType != null ? $optionsData.couponType[item.couponType].labelEn : "" }}
      </span>
    </div>
    <div class="coupon-price-content">
      <template v-if="item.couponType == 0 || item.couponType == 1 || item.couponType == 3">
        <div class="coupon-price">
          <span class="price-symbol" v-if="item.couponType != 1">￥</span>
          <span>{{ item.couponValue }}</span>
          <span class="price-symbol" v-if="item.couponType == 1">折</span>
          <span v-if="item.couponType == 1" style="margin-left: 15px;">{{ getCouponValue(item.couponValue) }}</span>
          <span v-if="item.couponType == 1" class="price-symbol"> off</span>
        </div>
      </template>
      <template v-else>
        <div class="coupon-name sl-ellipsis">{{ item.name }} {{ item.enName }}</div>
      </template>
    </div>
    <div class="coupon-item-bottom">
      <div v-if="item.writeOffConditionSwitch == 1">
        满￥{{ item.writeOffConditionPrice }}可用
      </div>
      <div v-if="item.writeOffConditionSwitch == 1">
        Available for payments over ￥{{ item.writeOffConditionPrice }}
      </div>
      <div v-if="item.writeOffLimitType == 0">
        通用券 General Coupons
      </div>
      <div v-else-if="item.writeOffLimitType == 1">
        <div>
          适用于{{ item.writeOffLimitCategoryName }}
        </div>
        <div>
          Available for {{ item.writeOffLimitCategoryNameEn }}
        </div>
      </div>

      <div v-else-if="item.writeOffLimitType == 2">
        <div>
          适用于{{ item.writeOffLimitChannelName }}
        </div>
        <div>
          Available for {{ item.writeOffLimitChannelNameEn }}
        </div>
      </div>

      <div v-else-if="item.writeOffLimitType == 3">
        适用于指定商品 Available for Specified Commodity
      </div>
      <div v-else-if="item.writeOffLimitType == 4">
        适用于订房 Available for Room Reservation
      </div>
      <div v-else-if="item.writeOffLimitType == 5">
        适用于指定房型 Available for Specified Room Type
      </div>
      <div v-if="item.couponType == 1">最高可抵: ￥{{item.discountMaxAmount }}</div>
      <div v-if="item.couponType == 1">The highest: ￥{{ item.discountMaxAmount }}</div>
      <div>有效期: {{ item.validStartTime }}至{{ item.validEndTime }}</div>
      <div> Expiry date: {{ item.validStartTime }}to{{ item.validEndTime }}</div>

    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {
      },
    },
    id: {
      type: [Number, String],
    },
  },
  data() {
    return {};
  },
  computed: {
    getCouponValue() {
      return function (couponValue) {
        if (typeof couponValue === "string")
          parseInt(couponValue)
        return `${100 - couponValue * 10}%`
      }

    }
  },
  watch: {},
  methods: {},
  created() {
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.coupon-item {
  width: 420px;
  height: 240px;

  &.active-coupon-item {
    border: 1px solid #333333;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      right: 0;
      bottom: -1px;
      width: 20px;
      height: 20px;
      background: url("~@/assets/img/checked-icon.png") 0 0 / 100% 100% no-repeat;
    }
  }

  background: #ffffff;
  border: 1px solid #cccccc;
  //margin-right: 30px;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  margin-bottom: 20px;

  .coupon-type {
    font-size: 13px;
    font-weight: bold;
    color: #333333;
  }

  .coupon-price-content {
    display: flex;
    align-items: flex-end;
    margin-top: 18px;

    .coupon-price {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
      flex-shrink: 0;
      -webkit-flex-shrink: 0;

      .price-symbol-small {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }
    }

    .writeoff-condition {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      margin-left: 19px;
      overflow: hidden;
      flex-shrink: 1;
      -webkit-flex-shrink: 1;

      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        -ms-text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        display: block;
      }
    }
  }

  .coupon-item-bottom {
    font-size: 14px;
    color: #999999;
    margin-top: 18px;
    position: relative;

    div {
      line-height: 20px;
      div{
        line-height: 20px;
      }
    }

    .mar-t-8 {
      margin-top: 8px;
    }
  }

  .coupon-name {
    line-height: 1.2;
    height: 30px;
  }
}
</style>
